import DashboardContentWrapper from '../../../shared/components/dashboard-content-wrapper'
import { TypographyH4 } from '../../../shared/components/ui/typography'
import Heading from '../../../shared/components/ui/typography/heading'
import React from 'react'
import SettingNotificationsForm from '@/features/settings/forms/setting-notifications-form'
import { useQuery } from '@tanstack/react-query'
import { useSession } from '@/features/auth/context/session.context'
import { getSettings, SETTINGS_QUERY_KEYS } from '@/features/settings/api/settings.api'

function SettingsPage() {
    const { session } = useSession()
    const userId = session?.sub

    const { data: res, isLoading, error } = useQuery({
        queryKey: SETTINGS_QUERY_KEYS.detail(userId!),
        queryFn: () => getSettings(userId!),
        enabled: !!userId,
    })

    if (isLoading) {
        return (
            <div className="flex h-64 w-full items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        )
    }

    if (error || !res || !res.success) {
        return (
            <DashboardContentWrapper>
                <Heading>Settings</Heading>
                <div className="text-destructive mt-5">Failed to load settings.</div>
            </DashboardContentWrapper>
        )
    }

    const { chatNotifications, workOrderNotifications } = res.data

    return (
        <DashboardContentWrapper className="flex flex-col gap-5 pb-24 md:pb-5">
            <div className='flex justify-between items-center'>
                <Heading>Settings</Heading>
            </div>
            <div className='border p-5 rounded space-y-5 hidden'>
                <TypographyH4>Notifications</TypographyH4>
                <SettingNotificationsForm
                    defaultValues={{
                        chatNotifications,
                        workOrderNotifications,
                    }}
                />
            </div>
        </DashboardContentWrapper>
    )
}

export default SettingsPage